/*
 * Descarga forzada de PDFs alojados en el CDN de Shopify.
 *
 * POR QUE HACE FALTA JS
 * El atributo `download` de un <a> SOLO funciona cuando el archivo esta en el
 * mismo origen que la pagina. Los PDFs de Shopify viven en cdn.shopify.com y la
 * tienda en otro dominio, asi que el navegador ignora el atributo por completo:
 * el PDF se abre en el visor en lugar de bajarse. No es un bug del tema, es la
 * regla de seguridad del atributo.
 *
 * La salida es traerse el archivo con fetch, convertirlo en un blob del mismo
 * origen y disparar la descarga desde ahi. Funciona porque el CDN de Shopify
 * responde con `access-control-allow-origin: *` (verificado el 10 de septiembre
 * de 2026 contra CG2022-ClassSizingChart.pdf).
 *
 * USO
 * Marcar el enlace con data-pdf-download y dejar el href apuntando al archivo:
 *
 *   <a href="...pdf" data-pdf-download data-pdf-name="SizeChart.pdf">Descargar</a>
 *
 * Sin JS, o si el fetch falla, el enlace se comporta como cualquier <a>: abre el
 * PDF. Nunca se queda sin hacer nada.
 */
(function () {
  'use strict';

  var ATTR = 'data-pdf-download';
  var ESTADO = 'pdf-download--loading';

  function nombreDesde(a) {
    var explicito = a.getAttribute('data-pdf-name');
    if (explicito) return explicito;
    try {
      var ruta = new URL(a.href, window.location.href).pathname;
      return decodeURIComponent(ruta.split('/').pop()) || 'download.pdf';
    } catch (e) {
      return 'download.pdf';
    }
  }

  function bajar(blob, nombre) {
    var url = URL.createObjectURL(blob);
    var tmp = document.createElement('a');
    tmp.href = url;
    tmp.download = nombre;
    tmp.rel = 'noopener';
    document.body.appendChild(tmp);
    tmp.click();
    document.body.removeChild(tmp);
    // Darle al navegador un momento para empezar antes de soltar el objeto.
    setTimeout(function () {
      URL.revokeObjectURL(url);
    }, 60000);
  }

  document.addEventListener('click', function (evento) {
    var a = evento.target.closest('a[' + ATTR + ']');
    if (!a || !a.href) return;
    // Respetar los gestos de "abrir en otra pestana" del usuario.
    if (evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.button !== 0) return;

    evento.preventDefault();
    if (a.classList.contains(ESTADO)) return;

    var etiqueta = a.getAttribute('aria-label') || a.textContent;
    a.classList.add(ESTADO);
    a.setAttribute('aria-busy', 'true');

    fetch(a.href, { mode: 'cors', credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.blob();
      })
      .then(function (blob) {
        bajar(blob, nombreDesde(a));
      })
      .catch(function () {
        // Si el fetch no se pudo (CORS, red, archivo movido), abrir el PDF en
        // una pestana nueva. Peor que descargar, pero el usuario obtiene algo.
        window.open(a.href, '_blank', 'noopener');
      })
      .then(function () {
        a.classList.remove(ESTADO);
        a.removeAttribute('aria-busy');
        if (etiqueta) a.setAttribute('aria-label', etiqueta.trim());
      });
  });
})();
